import React, { useContext } from 'react'
import CheckBoxCollection from '@/components/boxes/CheckBoxCollection'
import { Context } from '@/components/Context'
import { shortenAddress } from '@/utils/shortenAddress'

const NavigationSubMenus = ({
    showAllSubmenus,
    setShowAllSubmenus,
}: {
    showAllSubmenus: boolean
    setShowAllSubmenus: (arg0: boolean) => void
}) => {
    const { currentAccount } = useContext(Context)

    return (
        <div>
            <h4>{shortenAddress(currentAccount ?? '')}&nbsp;</h4>
            <div className="padding-bottom artwork-box menu-wrapper-row width300">
                <div>
                    <h4 className={'small gray'}>&nbsp;&nbsp;&nbsp;Currency</h4>
                </div>
                <div>
                    <CheckBoxCollection
                        btnName="mCRAZY"
                        classStyles="width100"
                        checked={false}
                        handleClick={() => {}}
                    />
                    <CheckBoxCollection btnName="CRAZY" classStyles="width100" checked={true} handleClick={() => {}} />
                    <CheckBoxCollection btnName="$" classStyles="width100" checked={false} handleClick={() => {}} />
                </div>
            </div>
            <div className="padding-bottom artwork-box menu-wrapper-row width300">
                <div>
                    <h4 className={'small gray'}>&nbsp;&nbsp;&nbsp;Username</h4>
                </div>
                <input
                    className="width300"
                    placeholder="Max 10 characters"
                    onChange={(e) => {
                        // setUsername(e.target.value)
                    }}
                ></input>
            </div>
            <div className="height160"></div>
        </div>
    )
}

export default NavigationSubMenus
